import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

interface AvailabilityTooltipProps {
  targetEl: HTMLElement | null;
}

export function AvailabilityTooltip({ targetEl }: AvailabilityTooltipProps) {
  const [visible, setVisible] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => {
    setVisible(false);
    if (targetEl) {
      timerRef.current = setTimeout(() => setVisible(true), 200);
    }
    return () => clearTimeout(timerRef.current);
  }, [targetEl]);

  if (!visible || !targetEl) return null;

  const rect = targetEl.getBoundingClientRect();
  const text = targetEl.dataset.tooltip ?? "";
  const borderColor = getComputedStyle(targetEl).color;

  const gap = 6;
  const placeAbove = rect.top > 50;
  const top = placeAbove ? rect.top - gap : rect.bottom + gap;
  const left = rect.left + rect.width / 2;

  return createPortal(
    <div
      className={`availability-tooltip ${placeAbove ? "availability-tooltip--above" : "availability-tooltip--below"}`}
      style={{ top, left, borderColor }}
    >
      {text}
    </div>,
    document.body,
  );
}
